import API from "./axios"


// ===============================
// CREATE COLLECTION
// ===============================
export const createCollection = (data) =>
  API.post("/create-collection", data)


// ===============================
// GET COLLECTIONS
// ===============================
export const getCollections = () =>
  API.get("/get-collections")


// ===============================
// ADMIN COLLECTIONS
// ===============================
export const getCollectionsAdmin = () =>
  API.get("/get-collections-admin")


// ===============================
// UPDATE COLLECTION
// ===============================
export const updateCollection = (data) =>
  API.post("/update-collection", data)


// ===============================
// DELETE COLLECTION
// ===============================
export const deleteCollection = (id) =>
  API.delete("/delete-collection", { data: { id } })


// ===============================
// CREATE SUBCOLLECTION
// ===============================
export const createSubCollection = (data) =>
  API.post("/create-subcollection", data)


// ===============================
// GET SUBCOLLECTIONS
// ===============================
export const getSubCollections = (collection_id) =>
  API.get(`/get-subcollections?collection_id=${collection_id}`)


// ===============================
// UPDATE SUBCOLLECTION
// ===============================
export const updateSubCollection = (data) =>
  API.post("/update-subcollection", data)


// ===============================
// DELETE SUBCOLLECTION
// ===============================
export const deleteSubCollection = (id) =>
  API.delete("/delete-subcollection", { data: { id } })


// ===============================
// ADD PRODUCT TO COLLECTION
// ===============================
export const addProductToCollection = (data) =>
  API.post("/add-product-to-collection", data)


// ===============================
// REMOVE PRODUCT FROM COLLECTION
// ===============================
export const removeProductFromCollection = (id) =>
  API.delete("/remove-product-from-collection", { data: { id } })


// ===============================
// GET COLLECTION PRODUCT IDS
// ===============================
export const getCollectionProductIds = (collection = null, subcollection = null) => {

  let url = `/collection-product-ids`
  if(collection){
    url += `?collection=${collection}`
  }

  if (subcollection) {
    url += `&subcollection=${subcollection}`
  }

  return API.get(url)
}


// ===============================
// STORE COLLECTION STRUCTURE
// ===============================
export const getStoreCollections = () =>
  API.get("/store-collections")



//get product by collection and subcollection slug
export const getCollectionProducts = (collection, subcollection) => {

  let url = `collection-products-by-slug?collection=${collection}`

  if (subcollection) {
    url += `&subcollection=${subcollection}`
  }
  return API.get(url)

}